import config from '@/common/config.js'

function upload(params) {
	if(params.url.substr(0,1) != '/') params.url = '/' + params.url;
	
	let xhr = new XMLHttpRequest();
	
	//上传进度
	xhr.upload.onprogress = function(e) {
		//这里的e表示onprogress
		params.progress && params.progress(Math.round((e.loaded / e.total) * 100));
	}

	xhr.open('post', config.api + params.url, true);
	xhr.withCredentials = true;
	xhr.timeout = 1000 * 60 * 30;
	
	//服务器返回状态
	xhr.onreadystatechange = function() {
		if (xhr.readyState == 4){
			if(xhr.status == 200) {
				let res = JSON.parse(xhr.responseText);
				response(res, params.success, params.error);
			} else {
				dyEditor.toast.error("上传失败,请检查网络");
				
				// uni.showToast({
				// 	title	: '上传失败,请检查网络',
				// 	icon	: 'none',
				// })
				
				params.error && params.error(xhr);
			}
		} 
	}
	
	let token = dyEditor.getToken();
	
	xhr.setRequestHeader("X-Requested-With", "json");
	xhr.setRequestHeader("token", token);
	
	let formData = new FormData();
	formData.append('file', params.path);
	
	for(let key in params.form){
		formData.append(key, params.form[key]);
	}
	xhr.send(formData);
	
	// fetch(params.path).then(r => r.blob()).then(r => {
	// 	//上传文件
	// 	let formData = new FormData();
	// 	//blob地址转化为blob对象
	// 	//blob对象转为二进制文件
	// 	// let type = params.form.name.substring(params.form.name.length-2);
	// 	let file = new File([r], params.form.name, {
	// 		type: 'image/jpg'
	// 	});
		
	// 	formData.append('file', file);
		
	// 	for(let key in params.form){
	// 		formData.append(key, params.form[key]);
	// 	}
		
	// 	xhr.send(formData);
	// });
	
	return xhr;
}

function jsonp(params){
	if(params.url.substr(0,1) != '/') params.url = '/' + params.url;
	
	let callback	= 'test';//c_' + Math.random();
	let script      = document.createElement('script');
	script.onload   = res=>{ document.head.removeChild(script) }
	script.onerror  = res=>{ 
		document.head.removeChild(script); 
		dyEditor.toast.error("请求服务器发生错误！"); 
		// uni.showToast({
		// 	title	: '请求服务器发生错误！',
		// 	icon	: 'none',
		// });
	}
	script.src      = config.bucket + params.url + '&jsonp=' + callback;

	window[callback] = res=>{
		delete window[callback];
		response(res, params.success, params.error);
	}
	
	document.head.appendChild(script);
}

function request(params) {
	
	if(params.url.substr(0,1) != '/') params.url = '/' + params.url;
	
	const req = {
		url: config.api + params.url,
		withCredentials: true,
		success: (res) => {
			if (params.loading == true) {
				uni.hideLoading();
			}
			
			if (res.statusCode == 200) {
				response(res.data, params.success, params.error, params.dialog);
			} else {
				if(params.dialog){
					uni.showToast({
						title	: '请求服务器发生错误！',
						icon	: 'none',
					});
				} else {
					dyEditor.toast.error("请求服务器发生错误！");
				}
				return;
			}
		},
		fail: (err) => {
			if (params.loading == true) {
				uni.hideLoading();
			}
			if(params.dialog){
				uni.showToast({
					title	: '请求服务器发生错误！',
					icon	: 'none',
				});
			} else {
				dyEditor.toast.error("请求服务器发生错误！");
			}
		},
		complete: () => {
			params.complete && params.complete();
		}
	}

	if (params.data) {
		//POST
		req.method = 'POST';
		req.data = params.data;
		req.dataType = 'json';
		req.header		= {
			'content-type':'application/json;charset=utf-8',
		};

	} else {
		//GET
		req.method = 'GET';
		req.dataType = 'json';
		req.header = {
			'content-type': 'application/json;charset=utf-8',
		};
	}
	//console.log('params',params);
	if(!params.force){
		const token		= dyEditor.getToken();
		const version	= window.appVersion;
		
		if(token) 	req.header.token 			= token;
		if(version) req.header.editorVersion 	= version;
	} 	
	
	uni.request(req);
}

function response(res, success, error, dialog){
	switch (res.code) {
		case 0:
			success && success(res.data);
			break;
	
		case 1: //用户未登录
			dyEditor.clearToken();
			// window.location.href = config.server + '/#/pages/login/login';
			uni.redirectTo({
				url:'../login/login',
			})
			break;
	
		default:
			if (error) return error(res);
			
			if(dialog){
				uni.showToast({
					title	: res.msg || '发生未知错误.',
					icon	: 'none',
				});
			} else {
				dyEditor.toast.error(res.msg || '发生未知错误.');
			}
			
			break;
	}
}

export default {
	upload	: upload,
	request	: request,
	jsonp	: jsonp,
}
